import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

const TabModal = inject("commonStore")(
  observer((props) => {
    const history = useHistory();

    /** 검수 완료 글 업로드시, 선택할 플랫폼 */
    const serData = [
      {
        id: "ser1",
        cont: "리데이트",
        color: "white",
        background: "#1D83E9",
      },
      {
        id: "ser2",
        cont: "포데이트",
        color: "#767676",
        background: "#F1F1F1",
      },
      {
        id: "ser3",
        cont: "relove",
        color: "#767676",
        background: "#F1F1F1",
      },
      {
        id: "ser4",
        cont: "reuniondate",
        color: "#767676",
        background: "#F1F1F1",
      },
      {
        id: "ser5",
        cont: "reunionlove",
        color: "#767676",
        background: "#F1F1F1",
      },
    ];
    const [serState, setSerState] = useState(serData); // 업로드 서비스 state
    const changeHandler = (i, cont) => {
      //태그 클릭 시 디자인 변경 및 리스트 추가
      props.setTags([...props.tags]);
      if (props.tags[i].checked) {
        // 체크 된 태그를 클릭할 때
        props.setFilterTag(props.filterTag.filter((v) => v !== cont)); //클릭한 태그 제거
        props.tags[i].checked = false;
        props.tags[i].background = "#F1F1F1";
        props.tags[i].color = "#767676";
        if (props.filterTag.length === 1) {
          // 할일 목록 태그 off
          props.commonStore.setTodo(2, 6);
        }
      } else {
        // 체크 안 된 태그를 클릭할 때
        if (props.filterTag.length > 4) {
          alert("태그는 5개 이하여야 합니다.");
        } else {
          props.tags[i].checked = true;
          props.tags[i].background = "#1D83E9";
          props.tags[i].color = "white";
          props.setFilterTag((v) => [...v, cont]);
          props.commonStore.setTodo(1, 6); // 할일 목록 태그 on
        }
      }
    };

    const closeModal = (num) => {
      // 모달 창 닫기
      if (num === 0) {
        // 그냥 닫기
        props.setDisBox("none");
        for (let i in props.tags) {
          props.setTags([...props.tags]);
          props.tags[i].checked = false;
          props.tags[i].background = "#F1F1F1";
          props.tags[i].color = "#767676";
        }
      } else if (num === 1) {
        if (props.filterTag.length === 0) {
          //태그를 추가하지 않으면?
          alert("태그를 추가해주세요!");
        } else {
          props.setDisBox("none");
          for (let i in props.tags) {
            props.setTags([...props.tags]);
            props.tags[i].checked = false;
            props.tags[i].background = "#F1F1F1";
            props.tags[i].color = "#767676";
          }
        }
      } else if (num === 2) {
        props.setIsComp(false);
        props.setDisBox("none");
        window.location.reload();
      }
    };

    const handleRadio = (e) => {
      let obj = {};
      obj[e.target.value] = e.target.checked;
      props.setSerRadio(obj); // 유저가 선택한 값 전달
      setSerState([...serState]);
      // console.log(props.serRadio) // 어떤 서비스에 업로드할지 선택한 값
      // console.log(props.serRadio[0]) // 어떤 서비스에 업로드할지 선택한 값
      // console.log(serState) // 어떤 서비스에 업로드할지 선택한 값

      //   console.log("wordpressCategories:", props.wordpressCategories)
      //   console.log("wordpressCategories:", props.wordpressCategories.categories)
      //   console.log("wordpressCategories:", typeof(props.wordpressCategories))

      for (let i in serState) {
        // 선택된 라벨의 색상 변경
        if (obj[i] === true) {
          serState[i].background = "#1D83E9";
          serState[i].color = "white";
        } else {
          serState[i].background = "#F1F1F1";
          serState[i].color = "#767676";
        }
      }
    };

    const [selectedTagsValues, setSelectedTagsValues] = useState([]);
    const [selectedCategoriesValues, setSelectedCategoriesValues] = useState([]);

    const handleTagsSelect = (e) => {
      const selectedValue = e.target.value;
      const isSelected = selectedTagsValues.includes(selectedValue);

      let updatedValues;
      if (isSelected) {
        // 이미 선택한 값이라면 제거
        updatedValues = selectedTagsValues.filter((value) => value !== selectedValue);
      } else {
        // 새로운 값이라면 추가
        updatedValues = [...selectedTagsValues, selectedValue];
      }

      setSelectedTagsValues(updatedValues);
      //   console.log("updatedValues:", updatedValues) // 선택한 태그 or 카테고리의 id 값
      props.commonStore.setWordpressTags(updatedValues);
    };

    const handleCategoriesSelect = (e) => {
      const selectedValue = e.target.value;
      const isSelected = selectedCategoriesValues.includes(selectedValue);

      let updatedValues;
      if (isSelected) {
        // 이미 선택한 값이라면 제거
        updatedValues = selectedCategoriesValues.filter((value) => value !== selectedValue);
      } else {
        // 새로운 값이라면 추가
        updatedValues = [...selectedCategoriesValues, selectedValue];
      }

      setSelectedCategoriesValues(updatedValues);
      //   console.log("updatedValues:", updatedValues) // 선택한 태그 or 카테고리의 id 값
      props.commonStore.setWordpressCategories(updatedValues);
    };

    return (
      <Box style={{ display: props.disBox }}>
        <div>
          {props.mode.tag ? (
            <>
              <div>
                <span>태그 추가</span>
                <img onClick={() => closeModal(0)} src={require("../../styles/img/close.png")} alt={"닫기"} />
              </div>
              <div className="tab_list">
                {props.tags.map((v, i) => {
                  return (
                    <label key={v.id}>
                      <div style={{ color: v.color, background: v.background }}>
                        <input type="checkbox" name="tabs" value={v.value} checked={v.checked} onChange={() => changeHandler(i, v.cont)} />
                        {v.cont}
                      </div>
                    </label>
                  );
                })}
              </div>
              <div className="confirm" onClick={() => closeModal(1)}>
                추가
              </div>
            </>
          ) : props.mode.upload ? (
            <>
              <div>
                <span></span>
                <img onClick={() => closeModal(0)} src={require("../../styles/img/close.png")} alt={"닫기"} />
              </div>
              <div className="text_box">
                <p>업로드할 서비스를</p>
                <p>선택해주세요</p>
                <br />
                <div>
                  {serState.map((v, i) => {
                    return (
                      <>
                        <span className="select_upload" style={{ background: v.background, color: v.color }} key={v.id}>
                          <input
                            type="radio"
                            id={v.id}
                            value={i}
                            name="services"
                            style={{ display: "none" }}
                            checked={props.serRadio[i]}
                            onChange={handleRadio}
                          />
                          {/* 업로드할 서비스 선택용 버튼 */}
                          <label className="upload_platform" htmlFor={v.id}>
                            {v.cont}
                          </label>
                        </span>
                      </>
                    );
                  })}
                </div>
                <div className="wordpress_option">
                  {Object.keys(props.serRadio)[0] === "0" || Object.keys(props.serRadio)[0] === "1" ? (
                    <></>
                  ) : (
                    <>
                      {/* 워드프레스 도메인을 선택한 경우, 태그와 카테고리를 불러와서 선택가능하도록 출력 */}
                      <div className="wordpress_option">
                        <p>업로드 시 등록할 태그와 카테고리를 선택해주세요.</p>

                        <div className="wordpress_option_container">
                          <p>태그</p>
                          <div className="wordpress_tags">
                            <div className="tab_list">
                              {props.wordpressTags.tags &&
                                props.wordpressTags.tags.map((tag, index) => {
                                  return (
                                    <label key={tag.id}>
                                      <div className="tags">
                                        <input type="checkbox" name="tabs" value={tag.id} onChange={handleTagsSelect} />
                                        {tag.name}
                                      </div>
                                    </label>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                        {/* <div className="wordpress_option_container">
                          <p>태그</p>
                          <div className="wordpress_tags">
                            <div className="tab_list">
                              {props.wordpressTags && props.wordpressTags.tags ? (
                                props.wordpressTags.tags.map((tag, index) => (
                                  <label key={tag.id}>
                                    <div className="tags">
                                      <input type="checkbox" name="tabs" value={tag.id} onChange={handleTagsSelect} />
                                      {tag.name}
                                    </div>
                                  </label>
                                ))
                              ) : (
                                <p>태그가 없습니다.</p>
                              )}
                            </div>
                          </div>
                        </div> */}

                        <div className="wordpress_option_container">
                          <p>카테고리</p>
                          <div className="wordpress_categories">
                            <div className="tab_list">
                              {props.wordpressCategories.categories &&
                                props.wordpressCategories.categories.map((category, index) => {
                                  return (
                                    <label key={category.id}>
                                      <div className="categories">
                                        <input type="checkbox" name="tabs" value={category.id} onChange={handleCategoriesSelect} />
                                        {category.name}
                                      </div>
                                    </label>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="final">
                {/* 서비스 선택 후 업로드 실행 또는 모달 닫기 */}
                {/* 진행 상태 설정 - 5 : 업로드 완료 */}
                <span onClick={() => props.submitHandler(5)}>확인</span>
                <span onClick={() => closeModal(0)}>취소</span>
              </div>
            </>
          ) : props.mode.comp ? (
            <>
              <div>
                <span></span>
                <img onClick={() => closeModal(0)} src={require("../../styles/img/close.png")} alt={"닫기"} />
              </div>
              <div className="text_box">
                <p>{props.isComp ? "반려 처리 되었습니다." : "반려 처리 하시겠습니까?"}</p>
              </div>
              <div className="final">
                {props.isComp ? (
                  <span onClick={() => history.push("/main")}>확인</span>
                ) : (
                  <>
                    <span onClick={() => props.submitHandler(3)}>확인</span>
                    <span onClick={() => closeModal(0)}>취소</span>
                  </>
                )}
              </div>
            </>
          ) : props.mode.insp ? (
            <>
              <div>
                <span></span>
                <img onClick={() => closeModal(0)} src={require("../../styles/img/close.png")} alt={"닫기"} />
              </div>
              <div className="text_box">
                <p>검수 완료하면</p>
                <p>작성자가 바로 업로드 할 수 있게 됩니다.</p>
              </div>
              <div className="final">
                <span onClick={() => props.submitHandler(4)}>확인</span>
                <span onClick={() => closeModal(0)}>취소</span>
              </div>
            </>
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </Box>
    );
  })
);

const Box = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgb(0, 0, 0, 0.5);
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;

  .wordpress_option {
    text-align: center;

    .wordpress_option_container {
      border-radius: 8px;
      background-color: rgb(241, 241, 241);
      margin-top: 10px;
    }

    .wordpress_tags,
    .wordpress_categories {
      display: flex;
      width: 450px;
      height: auto;
      line-height: 30px;
      font-size: 0.9rem;
      justify-content: center;

      span {
        width: 80px;
        display: inline-block;
        font-weight: bold;
        color: red;
      }

      .tab_list {
        height: auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .tags,
        .categories {
          justify-content: space-around;
          margin-right: 8px;

          > input {
            margin-right: 3px;
          }
        }
      }
    }
  }

  .select_upload {
    margin: 5px;
    font-weight: bold;
    padding: 3px;
    border-radius: 5px;
  }

  > div {
    background: white;
    width: 550px;
    border-radius: 10px;
    box-sizing: border-box;
    padding: 25px;

    > div:first-child {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > span {
        font-weight: bold;
        font-size: 20px;
      }

      > img {
        width: 5%;
        cursor: pointer;
      }
    }

    > .tab_list {
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;

      > label {
        cursor: pointer;

        > div {
          border-radius: 8px;
          box-sizing: border-box;
          padding: 10px 20px;
          margin-right: 7px;
          margin-bottom: 7px;
          height: 35px;

          > input {
            display: none;
            pointer-events: none;
          }
        }
      }
    }

    > .text_box {
      display: flex;
      flex-direction: column;
      align-items: center;
      line-height: 1.5;
      color: #909090;
      font-size: 1rem;

      > div:last-child {
        margin-top: 10px;
        width: 80%;
        display: flex;
        justify-content: center;

        > span {
          margin-right: 8px;
          box-sizing: border-box;
          padding: 8px 15px;
          font-size: 15px;
          border-radius: 8px;

          > label {
            cursor: pointer;
          }
        }
      }
    }

    > .confirm {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #1d83e9;
      border-radius: 6px;
      color: white;
      margin-top: 20px;
      cursor: pointer;
      height: 50px;
    }

    > .final {
      display: flex;
      justify-content: flex-end;
      margin-top: 25px;

      > span {
        margin-left: 25px;
        font-size: 20px;
        color: #5e5e5e;
        cursor: pointer;
      }

      > span:first-child {
        color: #1d83e9;
      }
    }
  }
`;

export default TabModal;
